<template>
  <div class="country-stats stat-container" v-if="country">
    <div class="row head">
      <div class="ranking">
        <AnimatedValue v-bind:value="country.stats[0].rang"></AnimatedValue>
      </div>
        <h2  :class="['country-' + country.Id]">
          <transition name="fade">
            <span :key="country.Id">{{ country.Land }}</span>
          </transition>
        </h2>
      <div class="desc" v-if="$globals.isMobile">{{ label }}</div>
    </div>
    <div class="row label">
      <div>Rang</div>
      <div></div>
      <div>Punkt<wbr>wert</div>
    </div>
    <div class="row" v-for="(stat) in country.stats" :key="stat.id" v-if="!stat.hide">
        <div class="ranking">
          <AnimatedValue v-bind:value="parseInt(stat.rang)"></AnimatedValue>
        </div>
        <div class="category">
          <div class="category-name" >
            {{ stat.label }}
            <div class="tooltop" :data-tooltip="stat.tooltip" v-if="!$globals.isMobile">i</div>
          </div>
          <div class="category-bar">
            <div
              v-bind:class="{ bar: true, animateWidth: true }"
              v-bind:style="{ width: parseInt(stat.value) + '%' }">
            </div>
          </div>
        </div>
        <div class="category-value">
          <AnimatedValue v-bind:isFloat="true" v-bind:value="stat.value"></AnimatedValue>
        </div>
    </div>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimateValue.vue';

export default {
  name: 'countrystats',
  components: {
    AnimatedValue,
  },
  methods: {
    /*
    getRelation: (value) => {
      value = parseInt(value);
      let relationValue = 0;
      if (value < 20) relationValue = 20;
      else if (value >= 20 && value < 40) relationValue = 40;
      else if (value >= 40 && value < 60) relationValue = 60;
      else if (value >= 60 && value < 80) relationValue = 80;
      else if (value >= 80) relationValue = 100;
      return `relation-${relationValue}`;
    },
    */
  },
  data: () => ({
    label: 'Länderportrait',
    size: '10%',
  }),
  props: {
    country: {},
  },
};
</script>


<style scoped lang="scss">
.country-stats {
  border: 1px solid $color-border;
  border-radius: $border-radius;
  background-color: $color-bg-widget;

  .row {
    display: grid;
    //grid-template-columns: 71px 65% 15%;
    grid-template-columns: 15% 70% 15%;

    > * {
      justify-self: start;
    }

    > div:first-child {
      justify-self: center;
      align-self: center;
    }
    > div:last-child {
      // margin-left: $padding-min * 2;
    }

    &.head {
      height: 55px;
      padding: $padding-min 0;
      background-color: $color-bg-headline;
      color: $color-text-headline;

      h2 {
        font-size: 18px;
        font-weight: bold;
        justify-self: start;
        text-transform: uppercase;
        position: relative;
        width: 100%;
        text-align: left;

        span {
          position: absolute;
          top: calc(50%);
          left: 0;
          transform: translateY(calc(-50%));
          width: 115%;
        }
      }

      .country-uk {
        font-size: 28px;
      }

      .desc {
        font-size: 14px;
      }

      .ranking {
        width: 55px;
        height: 55px;
        margin: 0;
        align-self: center;
        color: $color-brand;
        background-color: $color-white;
        font-size: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      > div:last-child {
        align-self: end;
        font-size: 10px;
      }

    }
    &.label {
      margin-top: $padding-min;
      margin-bottom: -12px;
      height: 30px;
      font-size: 12px;
      color: $color-black;
      font-size: 13px;

      > div:first-child {
        align-self: start;
      }
      > div:last-child {
        align-self: flex-start;
      }
    }
  }

  .ranking {
    display: inline-block;
    width: 45px;
    height: 45px;
    margin: $padding-min;
    text-align: center;
    vertical-align: middle;
    background-color: $color-brand;
    border-radius: 50%;
    color: $color-white;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .category {
    width: 100%;
    align-self: start;
    text-align: left;
  }
  .category-name {
    position: relative;
    display: inline-block;
    text-align: left;
    margin-bottom: $padding-min;
    font-size: 14px;

    &:hover {
      cursor: help;
    }
  }
  .category-bar {
    position: relative;
    width: 100%;
    height: 12px;
    background-color: $color-bg-bar;

    .bar {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      background-color: $color-bar;
    }
  }
  .category-value {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    /*
    justify-self: start;
    align-self: center;
    */
    color: $color-bar;
    font-weight: bold;
    font-size: 17px;
  }
}
</style>
